import { render, staticRenderFns } from "./specificInfo.vue?vue&type=template&id=62a491c2&scoped=true"
import script from "./specificInfo.vue?vue&type=script&lang=js"
export * from "./specificInfo.vue?vue&type=script&lang=js"
import style0 from "./specificInfo.vue?vue&type=style&index=0&id=62a491c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a491c2",
  null
  
)

export default component.exports